import { render, staticRenderFns } from "./top_sources.vue?vue&type=template&id=3d95d517"
import script from "./top_sources.vue?vue&type=script&lang=js"
export * from "./top_sources.vue?vue&type=script&lang=js"
import style0 from "./top_sources.vue?vue&type=style&index=0&id=3d95d517&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports